import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef} from '@angular/material/dialog';
import { PermissoesService } from 'app/service/usuario/permissoes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-include-unique-permission',
  templateUrl: './include-unique-permission.component.html',
  styleUrls: ['./include-unique-permission.component.scss']
})
export class IncludeUniquePermissionComponent implements OnInit {

  permissoes : any[];
  permissoesNotIn : any[];
  message;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<IncludeUniquePermissionComponent>,
  private permissoesService : PermissoesService,
  private _snackBar: MatSnackBar) {

    this.permissoesNotIn = [ ];
    

    permissoesService.getPermissionNotIn(data.usuario.id, this.data.dataDialog.id).subscribe(res =>{
      this.permissoes = res;
    });


    permissoesService.getPermissionIn(data.usuario.id, this.data.dataDialog.id).subscribe(res =>{
      this.permissoesNotIn = res;
    });


   }

  ngOnInit() {
    
  }

  openSnackBarErro() {
    var action = 'Fechar';
    this._snackBar.open(this.message, action, {
      duration: 4000,
      panelClass: ['error-metadados']
    });
    this.message = "";
  }

  openSnackBarSuccess() {
    var action = 'Fechar';
    this._snackBar.open(this.message, action, {
      duration: 3000,
      panelClass: ['success-metadados']
    });
  }

  addPermission(permission){

    this.permissoesNotIn.push(permission);
    let posi = this.permissoes.indexOf(permission);
    this.permissoes.splice(posi, 1);

  }


  removerPermission(permission){

    this.permissoes.push(permission);
    let posi = this.permissoesNotIn.indexOf(permission);
    this.permissoesNotIn.splice(posi, 1);

  }

  salvarPermissoes(){



      let obj = { "cliente": this.data.dataDialog, "usuario" : this.data.usuario, "permissions" : this.permissoesNotIn};

      console.log(obj)
      this.permissoesService.postPerssionsCliente(obj).subscribe(res =>{
        console.log(res)
        this.dialogRef.close(true);

      }, error =>{
        this.message = error;
        this.openSnackBarErro();
      })

    }



}



// WEBPACK FOOTER //
// /app/src/app/include-unique-permission/include-unique-permission.component.ts